// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-modal {
    background: #00000045;
}

.modal-title-24-800 {
    color: var(--base-900-light, #1A1A1A);
    /* text-xs/text-2xl/font-extrabold */
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 34px;
    /* 141.667% */
}

.modal-subtitle-18-500 {
    color: var(--base-900-light, #1A1A1A);

    /* text-xs/text-lg/font-medium\$ */
    font-family: Helvetica Neue;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px;
    /* 166.667% */
}`, "",{"version":3,"sources":["webpack://./src/components/modal/css/indexModal.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,qCAAqC;;IAErC,iCAAiC;IACjC,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB","sourcesContent":[".bg-modal {\n    background: #00000045;\n}\n\n.modal-title-24-800 {\n    color: var(--base-900-light, #1A1A1A);\n    /* text-xs/text-2xl/font-extrabold */\n    font-family: Inter;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 34px;\n    /* 141.667% */\n}\n\n.modal-subtitle-18-500 {\n    color: var(--base-900-light, #1A1A1A);\n\n    /* text-xs/text-lg/font-medium$ */\n    font-family: Helvetica Neue;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 30px;\n    /* 166.667% */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
